// extracted by mini-css-extract-plugin
export default {"navbar":"CustomerHeader_navbar__9xWmR"};